import React from 'react';
import { Box, Text } from "grommet"

const ShowLoading = () => (
    <Box fill background="light-3" justify="center" align="center">
        <Box align="center" justify="start" alignContent="start" pad="none" gap="none" margin="none">
            <Text weight="bold" color="dark-3" size="xlarge">
                Page is Loading...
            </Text>
            <Text weight="bold" color="brand" size="small">
                Please Wait
            </Text>
        </Box>
    </Box>
)

export default ShowLoading
